import { render, staticRenderFns } from "./administrationPost.vue?vue&type=template&id=5c09b730&"
import script from "./administrationPost.vue?vue&type=script&lang=js&"
export * from "./administrationPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports